export default {
  data() {
    return {
      showChoosePerson: false, // 人员选择
      areaData: [], // 树
      belongStaffList: [], // 历史指派人员
      changebelongStaffList: [], // 修改后的指派人员
      belongStaffs: [], // 勾选的指派人员
      customerGuids: []
    }
  },
  computed: {
    haveBelongStaff() {
      return this.belongStaffList.length || this.changebelongStaffList.length
    },
    disabled() {
      return this.$route.query.disabled ? true : false
    },
    isAudit() {
      return this.$route.query.isAudit ? true : false
    },
  },
  mounted() {
    if (this.$route.query.tenantGuid)  {
      this.$set(this.ruleForm,'tenantGuid',this.$route.query.tenantGuid)
    }
  },
  methods: {
    onChangetenantGuid(val) {
      this.serviceTenantGuid = val
      this.getOrganisation()
    },
    getServiceTenants() {
      const tenantGuid = this.serviceTenantGuid;
      const params = {
        tenantGuid: tenantGuid,
        isService: false,
      }
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-service-tenants`,
          params,
        )
        .then((res) => {
          if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.error(res.data.msg);
            return;
          }
          this.serviceTenants = res.data.data;
        });
    },
    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            if (!this.ruleForm.tenantGuid) {
              this.$set(this.ruleForm,'tenantGuid',self.tenantList[0].sendTenantGuid)
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // #业务指派人员相关逻辑===============
    popupBox() {
      this.areaData = [];
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('请先选择公司');
        return;
      }
      this.serviceTenantGuid = this.ruleForm.tenantGuid,
      this.showChoosePerson = true;
      this.getOrganisation();
      this.getServiceTenants();
    },
    //获取组织
    getOrganisation() {
      let query = {
        tenantGuid: this.ruleForm?.tenantGuid || this.$store.getters.getTenantGuid,
      }
      if (this.serviceTenantGuid) {
        query.tenantGuid = this.serviceTenantGuid;
      }
      this.dialogLoading = true;
      this.api
        .postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree`, query)
        .then((res) => {
          this.dialogLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.areaData = res.data.data;
            this.treeData(this.areaData);
            console.log(this.areaData);
          } else {
            this.$message.error(res.data.msg);
            this.areaData = [];
          }
        });
    },
    treeData(areaData) {
      const fn = (tree) => {
        tree.forEach(async (k) => {
          k.label = `${k.name}${k.mobileNo || ''}`;
          k.staffName = k.name;
          k.mobileNo = k.mobileNo;
          k.id = k.guid;
          k.staffGuid = k.guid;
          k.bizState = 'Y' // !默认有效
          k.icon = k.nodeType === '2' ? require('@/assets/images/icon_per.png') : require('@/assets/images/ico_ora.png');
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
            k.staffList = [];
            if (k.staffs) {
              k.staffs.forEach((d) => {
                let item = {
                  usertype: 1,
                  bizState:'Y', // !默认有效
                  id: d.guid,
                  staffGuid: d.guid,
                  label: d.staffName + d.mobileNo,
                  //下面数据是我自己加上的,发请求需要
                  mobileNo: d.mobileNo,
                  staffName: d.staffName,
                  tenantGuid: d.tenantGuid,
                  organisationNames: '123',
                  positionName: '123',
                  roleNames: '123',
                  logonUser: '123',
                  icon: require('@/assets/images/icon_per.png'),
                };
                k.staffList.push(item);
              });
            }
            const person = k.staffList;
            const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== '[]';
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              isValid(person) && (k.children = [...k.children, ...person]);
              // 有子元素，需要调用自身
            } else {
              isValid(person) && (k.children = person);
            }
          }
        });
      };
      fn(areaData);
    },
    // 获取勾选的人员
    getPerson(res) {
      console.log(res);
      this.changebelongStaffList = res
    },
    existsCheckBlur(customerType) {
      if (!this.ruleForm.tenantGuid) return
      let queryLookUp = {
        '1': { // 药店
          url: `/${serverConfig.msCustomerService}/customer/data/exists-check`,
          param: {
            guid:this.$route.query.guid || '',
            tenantGuid: this.ruleForm.tenantGuid,
            customerName: this.ruleForm.customerName,
          },
          tipMsg:'该客户已存在，请勿重复建档'
        },
        '2': { // 商业公司
          url: `/${serverConfig.msCustomerService}/franchisee/data/exists-check`,
          param: {
            guid:this.$route.query.guid || '',
            tenantGuid: this.ruleForm.tenantGuid,
            franchiseeName: this.ruleForm.franchiseeName,
          },
          tipMsg:'该客户已存在，请勿重复建档'
        },
        '3': {}, // 医生
        '4': { // 医院
          url: `/${serverConfig.msCustomerService}/med/data/exists-check`,
          param: {
            guid:this.$route.query.guid || '',
            tenantGuid: this.ruleForm.tenantGuid,
            medName: this.ruleForm.medName,
          },
          tipMsg:'该客户已存在，请勿重复建档'
        },
        '10': {}, // 商业公司客户
        '11': {}, // 居间人
      }
      const { url }  = queryLookUp[customerType]
      const { param }  = queryLookUp[customerType]
      const { tipMsg }  = queryLookUp[customerType]
      if (url && param) {
        this.api.postJson(url, param).then(res=>{
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
            this.$message.warning(tipMsg);
          }
        })
      }
    }
  },
}